import About from "../components/Common/About";

function AboutPage(){
    return (
        <About/>
    )
}

export default AboutPage;